import React, { Fragment, Component, useState, useEffect } from 'react';
import { Button, Navbar, Nav } from 'react-bootstrap';
import { Auth, AuthState, onAuthUIStateChange, getCurrentAuthState } from '../api';
import { Authenticator } from './Auth/Authenticator';
import { NavLink } from 'react-router-dom';
import {ReactComponent as ChocolateDonut} from '../ChocolateDonut.svg';

const appName = 'the Doughnut Review';
function StylizedAppName() {
    return (
      <div>
        <ChocolateDonut width="24px"></ChocolateDonut>
        <span className="logoText" style={{color: "#1A040E", marginLeft: ".25ch"}}>|</span>
        <span className="logoText" style={{fontWeight: "300", color: "#1A040E", marginLeft: ".25ch", verticalAlign: "bottom"}}>the</span>
        <span className="logoText" style={{color: "#1A040E", marginLeft: ".25ch", verticalAlign: "bottom"}}>Doughnut Review</span>
      </div>
    );
}

function StylizedAppNameLink(props) {
  if(props.showHomeLink === false) {
    return (<StylizedAppName />);
  }
  return (
    <NavLink to={`/`}><StylizedAppName /></NavLink>
  );
}

function NavigationBarSwitcher(props) {
  if(props.authState !== 'signedIn') {
      return (
          <SignedOutNavigationBar showHomeLink={props.showHomeLink}></SignedOutNavigationBar>
      );
  }
  return (<NavigationBar showHomeLink={props.showHomeLink}></NavigationBar>);
}

class NavigationBar extends React.Component {
    render() {
      console.log("Rendering NavigationBar");
        return (
                <Navbar collapseOnSelect expand="lg" bg="nav" variant="light" fixed="top">
                <Navbar.Brand>
                      <StylizedAppNameLink showHomeLink={this.props.showHomeLink}/>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="mr-auto">
                    </Nav>
                    <Nav>
                    { getCurrentAuthState().user?.isHighTrust &&
                    <Navbar.Text style={{paddingLeft: ".5rem", paddingRight: ".5rem"}}>
                      <NavLink to={`/manage`}>Manage</NavLink>
                    </Navbar.Text>
                    }
                    <Navbar.Text style={{paddingLeft: ".5rem", paddingRight: ".5rem"}}>
                      <NavLink to={`/me`}>Profile</NavLink>
                    </Navbar.Text>
                    <div style={{ display: "inline-block" }}>
                      <Authenticator>
                        <SignOutButton override={'SignOut'} fontSize="1rem" skipPadding={true}/>
                      </Authenticator>
                    </div>
                    </Nav>
                </Navbar.Collapse>
                </Navbar>
        );
    }
}

function useAuthRedirect(action) {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const reset = () => setLoading(false);
    window.addEventListener("pageshow", reset);
    return () => window.removeEventListener("pageshow", reset);
  }, []);

  const trigger = async () => {
    if (loading) return;
    setLoading(true);
    try { await action(); } catch { setLoading(false); }
  };
  return { loading, trigger };
}

const useSignIn = () => useAuthRedirect(Auth.signIn.bind(Auth));
const useSignUp = () => useAuthRedirect(Auth.signUp.bind(Auth));

function SignedOutNavigationBar(props) {
  const { loading: signInLoading, trigger: signIn } = useSignIn();
  const { loading: signUpLoading, trigger: signUp } = useSignUp();

  useEffect(() => {
    return onAuthUIStateChange((nextAuthState) => {
      if (nextAuthState === AuthState.SignedIn) {
        window.location.reload(false);
      }
    });
  }, []);

  return (
    <Navbar collapseOnSelect expand="lg" bg="nav" variant="light" fixed="top">
      <Navbar.Brand>
        <StylizedAppNameLink showHomeLink={props.showHomeLink}/>
      </Navbar.Brand>
      <Nav className="mr-auto" />
      <Nav>
        <div style={{ display: "inline-block" }}>
          <Button
            className="headerTextLight"
            onClick={signIn}
            disabled={signInLoading}
            variant="outline-dark"
            style={{ verticalAlign: "text-bottom" }}
          >
            Sign In
          </Button>
          <div style={{ display: "inline-block", width: "12px" }} />
          <Button
            onClick={signUp}
            disabled={signUpLoading}
            className="headerTextLight"
            variant="outline-dark"
            style={{ verticalAlign: "text-bottom" }}
          >
            Sign Up
          </Button>
        </div>
      </Nav>
    </Navbar>
  );
}

class SignOutButton extends Component {
    constructor() {
      super();
      this.gotoSignOut = this.gotoSignOut.bind(this);
    }

    gotoSignOut() {
        Auth.signOut();
    }

    render() {
      console.log("Rendering SignOutButton");
      var fontSize = "12px";
      if(this.props.fontSize) {
          fontSize = this.props.fontSize;
      }
      var padding = <Button onClick={this.gotoSignOut}  className="headerTextLight" variant="outline-dark" style={{fontSize: fontSize, padding: "0px 6px 0px 6px", verticalAlign: "text-bottom"}}>Sign Out</Button>;
      if(this.props.isOutline) {
          padding = <Button onClick={this.gotoSignOut}  className="headerTextLight" variant="outline-light" style={{fontSize: fontSize, padding: "0px 6px 0px 6px", verticalAlign: "text-bottom"}}>Sign Out</Button>;
      }
      else if(this.props.skipPadding) {
          padding = <Button onClick={this.gotoSignOut}  className="headerTextLight" variant="outline-dark" style={{fontSize: fontSize, verticalAlign: "text-bottom"}}>Sign Out</Button>;
      }
      return (
        <div>
          { this.props.authState === 'signedIn' &&
          <div id="blerg" style={{display: "inline-block"}}>
              {padding}
          </div>
          }
        </div>
      );
    }
  }


class SignInButton extends Component {
  render() {
    console.log("Rendering SignInButton");
    return (
      <Fragment>
          { this.props.authState !== 'signedIn' &&
            <Button className="headerTextLight" onClick={this.props.onSignInClicked} variant="outline-dark" style={{verticalAlign: "text-bottom"}}>Sign In</Button>
          }
      </Fragment>
    );
  }
}


class SignUpButton extends Component {
  render() {
    console.log("Rendering SignUpButton");
    return (
      <Fragment>
          { this.props.authState !== 'signedIn' &&
            <Button onClick={this.props.onSignUpClicked} className="headerTextLight" variant="outline-dark" style={{verticalAlign: "text-bottom"}}>Sign Up</Button>
          }
      </Fragment>
    );
  }
}



export { NavigationBarSwitcher, SignOutButton, SignedOutNavigationBar, StylizedAppName, StylizedAppNameLink };
